import { render } from "./GroupCardView.vue?vue&type=template&id=3583c218&scoped=true"
import script from "./GroupCardView.vue?vue&type=script&lang=js"
export * from "./GroupCardView.vue?vue&type=script&lang=js"

import "./GroupCardView.vue?vue&type=style&index=0&id=3583c218&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\a\\WebApp\\FAOU.App\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3583c218"]])

export default __exports__